import { DataEntry } from 'models/data';
import { Flag } from 'components/Flag';
import { useModelService } from 'services/model/model.service';
import { Card, Chip, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { getChipSxStylingForLevel } from 'styles/utils';
import { TbIcon } from 'components/Figma';

interface ExpansionOpportunityCardProps {
  expansionOpportunity: DataEntry;
  benchmark: string;
}

export function ExpansionOpportunityCard({ expansionOpportunity, benchmark }: ExpansionOpportunityCardProps) {
  const intl = useIntl();
  const { getAttribute } = useModelService();

  const modelService = useModelService();
  const retQtyRateExpOD = modelService.getMeasure('retQtyRateExpOD');

  const chnCountry = getAttribute('chnCountry');
  const benchmarkGroup = expansionOpportunity.benchmarks ? expansionOpportunity.benchmarks[benchmark] : undefined;

  const chipLevel = (benchmarkGroup?.values.growth ?? 0) > 0 ? 'Success' : 'Warning';

  return (
    <Card
      style={{
        justifyContent: 'left',
        border: '1px solid #e0e0e0',
        boxShadow: 'none',
        borderRadius: '8px',
        padding: '16px',
        width: '340px',
        marginRight: '20px',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '16px',
          borderBottom: '1px solid #e0e0e0',
          paddingBottom: '12px',
          marginBottom: '12px',
        }}
      >
        <Flag
          countryCode={expansionOpportunity.attributes.chnCountry.toLowerCase()}
          tooltip={chnCountry.getValue(expansionOpportunity.attributes)}
        />
        <Typography fontSize="18px" fontWeight={800}>
          {expansionOpportunity.attributes.chnMarketplace}
        </Typography>
      </div>
      <div style={{ display: 'flex', gap: '16px', justifyContent: 'left' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            borderRight: '1px solid #e0e0e0',
            paddingRight: '16px',
            marginRight: '16px',
            width: '50%',
          }}
        >
          <span>
            {intl.formatMessage({
              id: 'benchmarking.titles.expansion-opportunities-card.peerGrowth',
              defaultMessage: 'Peer Growth',
            })}
          </span>
          <Chip
            icon={<TbIcon name="TrendUp" />}
            size={'small'}
            label={`${(((benchmarkGroup?.values.growth ?? 1) - 1) * 100).toFixed(2)}%`}
            sx={getChipSxStylingForLevel(chipLevel, {
              width: '90px',
            })}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>
            {intl.formatMessage({ id: 'benchmarking.titles.chart.reaRetQtyRateOD', defaultMessage: 'Return Rates' })}
          </span>
          <Typography
            fontSize="14px"
            fontWeight={700}
          >{`${(retQtyRateExpOD.getValue(benchmarkGroup?.values) * 100).toFixed(2)}%`}</Typography>
        </div>
      </div>
    </Card>
  );
}
